<template>
    <div>
        <div id="ranking" style="width: 100%; height:520px;"/>
    </div>
</template>
<script>
import {reqOrderTurnoverStatistics} from "@/api/core/Home";
import * as echarts from 'echarts'

export default {
    name: 'OrderStatistics',
    async created() {
        await this.load();
    },
    mounted() {
        this.$nextTick(() => {
            this.drawChart();
        })
    },
    data() {
        return {
            query: {
                shopId: 3
            },
            dataList: [],
        }
    },
    methods: {
        async load() {
            let data = await reqOrderTurnoverStatistics(this.query);
            this.dataList = data;
        },
        async drawChart() {
            let data = await reqOrderTurnoverStatistics(this.query);
            this.dataList = data;
            //取days
            let days = data.map(item => item.days);
            //取orderAmount
            let orderAmount = data.map(item => item.orderAmount);
            //取orderCount
            let orderCount = data.map(item => item.orderCount);
            // 文章访问量排行
            this.ranking = echarts.init(document.getElementById('ranking'))
            // 绘制图表
            this.ranking.setOption({
                title: {
                    text: '最近一周店铺销售额'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: days,
                        axisTick: {
                            alignWithLabel: true
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],

                series: [
                    {
                        name: '销售额',
                        type: 'bar',
                        barWidth: '60%',
                        data: orderAmount
                    }, {
                        name: '订单数',
                        type: 'line',
                        barWidth: '60%',
                        data: orderCount
                    }
                ]
            })

            const that = this
            // 如果页面大小发生变化图表自适应
            window.onresize = function () {
                that.visits.resize()
                // 图表动态改变并渲染
                that.ranking.resize()
                that.category.resize()
            }
        }
    },

}
</script>
